import React = require('react');

interface IGoBack {
  history?: any;
  url?: string;
  push?: (url: string) => any;
  buttonStyle?: any;
}

export const GoBack = ({ history, url, push, buttonStyle }: IGoBack) => {

  const handleOnclick = () => {
    push(url);
  }

  const func = history ? history.goBack : null;

  return (
    <div className={'go-back-container'}>
      <div className={'go-back-button'} onClick={url && push ? handleOnclick : func} style={buttonStyle}>
        GO BACK
      </div>
    </div>
  )
}
